export const galleryItems = [
  {
    id: 1,
    title: "Wedding Elegance",
    desc: "Three-tier fondant masterpiece with delicate sugar flowers",
    category: "Wedding and Registration Cakes",
    image: "/images/gallery/wedding-cake2.jpg"
  },
  {
    id: 2,
    title: "Birthday Celebration",
    desc: "Custom character cake with hand-painted details",
    category: "Birthday Cakes",
    image: "/images/gallery/birthday-cake2.jpg"
  },
  {
    id: 3,
    title: "First Birthday",
    desc: "Adorable smash cake design perfect for baby's milestone",
    category: "First Birthday Cakes",
    image: "/images/gallery/first-birthday-cake.jpg"
  },
  {
    id: 4,
    title: "21st Birthday",
    desc: "Sophisticated celebration cake with elegant gold accents",
    category: "21st Birthday Cakes",
    image: "/images/gallery/21st-birthday-cake.jpg"
  },
  {
    id: 5,
    title: "Anniversary Bliss",
    desc: "Gold-accented romantic design with fresh flowers",
    category: "Anniversary Cakes",
    image: "/images/gallery/anniversary-cake2.jpg"
  },
  {
    id: 6,
    title: "Baby Shower",
    desc: "Pastel-themed buttercream with cute figurines",
    category: "Baby Shower Cakes",
    image: "/images/gallery/baby-shower-cake2.jpg"
  },
  {
    id: 7,
    title: "Puberty Ceremony",
    desc: "Traditional puberty ceremony cake with cultural motifs",
    category: "Puberty Ceremony Cakes",
    image: "/images/gallery/puberty-ceremony-cake.jpg"
  },
  {
    id: 8,
    title: "Butter, Chocolate & Red Velvet",
    desc: "Butter cake, chocolate cake, choco layered, or red velvet cake crafted exactly how you like it",
    category: "Butter / Chocolate / Choco Layered / Red Velvet Cakes",
    image: "/images/gallery/butter-cake.jpg"
  },
  {
    id: 9,
    title: "First Communion",
    desc: "Elegant white cake with religious symbols and cross details",
    category: "First Communion Cakes",
    image: "/images/gallery/first-communion-cake.jpg"
  },
  {
    id: 10,
    title: "Candy Table",
    desc: "Vibrant candy-themed decorations with custom centerpiece",
    category: "Candy Table Decorations",
    image: "/images/gallery/candy-table.jpg"
  },
  {
    id: 11,
    title: "Cupcake Collection",
    desc: "Assorted flavors with creative frosting designs",
    category: "Cupcakes",
    image: "/images/gallery/cupcakes.jpg"
  },
  {
    id: 12,
    title: "Piñata Surprise",
    desc: "Cake filled with colorful candies and treats inside",
    category: "Piñata Cakes",
    image: "/images/gallery/pinata-cake.jpg"
  },
  {
    id: 13,
    title: "Fondant Creation",
    desc: "Smooth fondant finish with intricate decorative details",
    category: "Fondant Cakes",
    image: "/images/gallery/fondant-cake.jpg"
  },
  {
    id: 14,
    title: "Unicorn Magic",
    desc: "Whimsical unicorn design with rainbow colors and sparkles",
    category: "Unicorn Theme Cakes",
    image: "/images/gallery/unicorn-cake.jpg"
  },
  {
    id: 15,
    title: "Bride To Be",
    desc: "Celebratory cake for bridal shower with elegant accents",
    category: "Bride To Be Cakes",
    image: "/images/gallery/bride-to-be-cake.jpg"
  },
  {
    id: 16,
    title: "Natural Flowers",
    desc: "Customizable cake adorned with fresh natural flowers of your choice",
    category: "Natural Flowers Cakes",
    image: "/images/gallery/natural-flowers-cake.jpg"
  }
  ,
  {
    id: 17,
    title: "Fondant Art",
    desc: "Artistic fondant sculpting and detailed edible designs",
    category: "Fondant Art Cakes",
    image: "/images/gallery/fondant-art-cake.jpg"
  },
  {
    id: 18,
    title: "Special Occasion",
    desc: "Unique celebration cakes tailored for any special event",
    category: "Special Occasion Cakes",
    image: "/images/gallery/special-occasion-cake.jpg"
  }
];
